<template>
  <div class="order-button-wrapper">
    <Button
      :variant="variant"
      type="a"
      :href="orderLink"
      @click.native="handleClick"
    >
      {{ $t('Заказать карту') }}
    </Button>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'
import Button from '@/common/components/Button'
import { getOrderUrl } from '@/helpers'

@Component({ components: { Button } })
class OrderButton extends Vue {
  @Prop({ type: String }) game
  @Prop({ type: String, default: 'contained' }) variant
  @State('country') currentCountry

  get orderLink () {
    return getOrderUrl(this.currentCountry, this.game)
  }

  handleClick () {
    this.$analytics.trackOrderClick({ screenId: this.$route.name, linkUrl: this.orderLink })
  }
}

export default OrderButton
</script>

<style lang="scss">
  .order-button-wrapper {
    display: flex;
    flex-direction: column;
    &_message {
      width: 100%;
      text-align: center;
      color: #e50026;
      font-size: 12px;
      line-height: 12px;
      transform: translateY(3px);
      @include media_tablet {
        transform: translateY(10px);
      }
    }
    a.disabled {
      pointer-events: none;
    }
  }
</style>
